<template>
	<div class="mb-1 clearfix">
		<div class="clearfix mb-0">
			<p class="float-left lh-1 mb-0" v-if="settings.caption">{{ settings.caption }}</p>
				<b-icon 
					v-if="offerTimeSeries && settings.ready"
			  		@click="displayPlot" 
			  		icon="bar-chart-line-fill" 
			  		font-scale="1.1" 
			  		class="ml-1"
			  	>
                </b-icon>
			<p class="float-right text-subtle font-normal lh-1 mb-0" v-if="settings.ready">
				<span :class="amountClass"
					><ICountUp :delay="0" :endVal="settings.value" :options="options" /></span
				><span v-if="settings.target && !hideTarget"
					>/<span class="text-sm">{{ settings.target }}</span></span
				>
			</p>
		</div>
		<div class="graph-indicators clearfix mb-1" v-if="settings.showquartiles">
			<Quartile
				v-for="(quartile, index) in settings.quartiles"
				v-bind:key="index"
				:lowerValue="settings.quartiles[index-1]"
				:upperValue="quartile"
				:maxValue="settings.quartiles[4]"
				:position="index"
			/>
		</div>
		<b-progress
			:value="settings.value"
			:max="maxAmount"
			:target="settings.target"
			:variant="variant"
			:class="progressClass"
		></b-progress>
	</div>
</template>

<script>
import ICountUp from "vue-countup-v2";
import Quartile from "./Quartile";

export default {
	components: {
		Quartile,
		ICountUp,
	},
	props: {
		settings: Object,
		student: Object,
        hideTarget: {
            type: Boolean,
            default: true
        },
        includeTimeSeries: {
            type: Boolean,
            default: false
        }
	},
	data() {
		return {
			value: 0,
			options: {
				useEasing: true,
				useGrouping: true,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
			},
			excludedDatasets: ['allstudentsreport','diligenceitems']
		};
	},
	mounted() {

	},
	methods: {
		displayPlot(){
            if(!this.settings.data) return;

			const data = this.settings.data.split('.');

			if (!this.excludedDatasets.includes(data[0])) {
				/*this.$store.commit("openModal", {
					type: "plot",
					chartTitle: `${this.settings.caption} for ${this.student.displayName}`,
					student: this.student,
					dataToPlot: data[0],
					field: data[1],
					target: this.settings.target
				});*/
                this.$emit('display-plot', this.settings.data);
            } else {
                console.error(`This dataset can't be plotted`)
            }
		},
	},
	watch: {

	},
	computed: {
		offerTimeSeries(){
			return  this.includeTimeSeries && !this.excludedDatasets.includes(this.settings.data.split('.')[0]);
		},	
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
		maxAmount() {
			if('percentage' in this.settings){
				return 100;
			}
			if ('max' in this.settings) {
				return Number(this.settings.max);
			}
			if (this.settings.target) {
				if (Number(this.settings.target) > Number(this.settings.value)) {
					return Number(this.settings.target);
				}
			}
			if(this.settings.showquartiles && this.settings.quartiles) {
				return Number(this.settings.quartiles[4]);
			}
			if (this.settings.median) {
				var max = Number(this.settings.median) * 2;
				if (max > Number(this.settings.value)) {
					return max;
				}
			}
			if (this.settings.quartiles) {
				return Number(this.settings.quartiles[4]);
			}
			return this.settings.value;
		},
		progressClass() {
			var cssclass = 'mb-3 w-full';
			if(!('ready' in this.settings) || !this.settings.ready){
				cssclass += ' skeleton';
			}
			if(('reversed' in this.settings) && this.settings.reversed == true){
				cssclass += ' justify-content-end';
			}
			return cssclass;
		},
		variant() {
			if(('neutral' in this.settings) && this.settings.neutral == true){
				return "neutral"
			}
			var value = Number(this.settings.value);
			var breakpoints = [];
			if (this.settings.target) {
				breakpoints = [
					0 ,
					Number(this.settings.target) * .5 ,
					Number(this.settings.target) * .75 ,
					Number(this.settings.target)
				];
			}
			else if (this.settings.showquartiles && this.settings.quartiles) {
				breakpoints = this.settings.quartiles
			}
			else if (Number(this.settings.median)){
				var max = Number(this.settings.median);
				breakpoints = [
					0 ,
					Number(max) * .25 ,
					Number(max) * .5 ,
					Number(max) * .75
				];
			}
			else if (this.settings.quartiles) {
				breakpoints = this.settings.quartiles
			}

			if(('inverted' in this.settings) && this.settings.inverted == true){
				if(value >= breakpoints[3]){
					return "first-quartile";
				}
				if(value >= breakpoints[2]){
					return "second-quartile";
				}
				if(value >= breakpoints[1]){
					return "third-quartile";
				}
				return "fourth-quartile";
			}

			if(value >= breakpoints[3]){
				return "fourth-quartile";
			}
			if(value >= breakpoints[2]){
				return "third-quartile";
			}
			if(value >= breakpoints[1]){
				return "second-quartile";
			}
			return "first-quartile";

		},
		amountClass() {
			return `text-${this.variant} font-bold`;
		}
	}
};
</script>
